module.exports = __webpack_public_path__ + "img/2c8e25c48dde1337796b713a07a2ef94.png";